export default {
    orders: {
        actionUndo: {
            message: "Wenn Sie irrtümlich geklickt haben, klicken Sie auf den Link unten, um zurückzukehren.",
            undo: "Klicken Sie zum Rückgängigmachen"
        }
    }
}